import useCompanies from './useCompanies'

const useCompanyTimeZone = (companyId: number): string | undefined => {
  const companiesQuery = useCompanies()

  return companiesQuery.data?.companiesMap.get(companyId)?.timeZone ?? undefined
}

export default useCompanyTimeZone
